<cdk-virtual-scroll-viewport #viewport itemSize="10" (scroll)="onScroll.emit($event)">
	<ul class="virtual-list">
		<ng-content></ng-content>
	</ul>
</cdk-virtual-scroll-viewport>
